import {
  AppBar as MuiAppBar,
  Button,
  InputBase as MuiInputBase,
  Toolbar as MuiToolbar,
  Typography,
} from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

export const AppBar = styled(MuiAppBar)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  zIndex: 0,
  boxShadow: theme.shadows[3],
  borderRadius: "3px",
}));

export const Toolbar = styled(MuiToolbar)({
  display: "flex",
  justifyContent: "space-between",
});

export const SearchContainer = styled("div")({
  display: "flex",
  alignItems: "center",
});

export const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.75),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.95),
  },
  width: "100%",
  marginLeft: 0,
  [theme.breakpoints.up("md")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

export const InputBase = styled(MuiInputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

export const Icon = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: "30px",
}));

export const DeleteButton = styled(Button)({
  fontSize: "1rem",
  padding: 0,
  cursor: "pointer",

  "&:hover": {
    backgroundColor: "transparent",
  },
});
